<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="svg-block" v-html="svg"></div>
</template>

<script setup lang="tsx">
const svg = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 469.44 234.626">
  <defs>
    <linearGradient id="linear-gradient" x1="1" y1="0.5" x2="0.023" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1,#000)"/>
      <stop offset="0.018" stop-color="var(--theme-color-1,#000)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
    <linearGradient id="linear-gradient-2" y1="0.5" x2="0.977" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-2,#000)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
    <linearGradient id="linear-gradient-3" y1="0.5" x2="0.977" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-1,#000)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
    <linearGradient id="linear-gradient-3-2-2" y1="0.5" x2="0.977" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="var(--theme-color-2,#000)"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
    <linearGradient id="linear-gradient-3-2" y1="0.5" x2="0.977" y2="0.5" gradientUnits="objectBoundingBox">
      <stop offset="0" stop-color="#a8a8a8"/>
      <stop offset="1" stop-color="#fff"/>
    </linearGradient>
    <linearGradient id="linear-gradient-4" x1="1" x2="0.023" xlink:href="#linear-gradient-3"/>
    <linearGradient id="linear-gradient-5" x1="1" x2="0.023" xlink:href="#linear-gradient-3-2-2"/>
  </defs>
  <g id="nianling1" transform="translate(-26.781 -61.187)">
    <ellipse id="椭圆_856" opacity='0.2' data-name="椭圆 856" cx="116.825" cy="116.824" rx="116.825" ry="116.824" transform="translate(26.781 61.524)" fill="url(#linear-gradient)"/>
    <ellipse id="椭圆_857" opacity='0.2' data-name="椭圆 857" cx="116.825" cy="116.825" rx="116.825" ry="116.825" transform="translate(261.596 61.524)" fill="url(#linear-gradient-2)"/>
    <ellipse id="椭圆_854" data-name="椭圆 854" cx="39.932" cy="39.932" rx="39.932" ry="39.932" transform="translate(181.541 135.259)" fill="var(--theme-color-1,#000)" stroke="#fff" stroke-width="3"/>
    <ellipse id="椭圆_1213" data-name="椭圆 1213" cx="39.932" cy="39.932" rx="39.932" ry="39.932" transform="translate(261.406 135.259)" fill="var(--theme-color-2,#000)" stroke="#fff" stroke-width="3"/>
    <text id="男性" transform="translate(207.51 179.94)" fill="#fff" font-size="14" letter-spacing="0.09em"><tspan x="0" y="0">男性</tspan></text>
    <text id="女性" transform="translate(285.285 179.94)" fill="#fff" font-size="14" letter-spacing="0.09em"><tspan x="0" y="0">女性</tspan></text>
    <path id="路径_5356" data-name="路径 5356" d="M169.172,446.73a117.313,117.313,0,1,1,82.953-34.36A116.545,116.545,0,0,1,169.172,446.73Zm0-233.649a116.336,116.336,0,1,0,82.263,34.074A115.575,115.575,0,0,0,169.172,213.08Z" transform="translate(209.736 -150.917)" fill="url(#linear-gradient-3-2-2)"/>
    <path id="路径_5357" data-name="路径 5357" d="M169.171,446.729a117.312,117.312,0,1,1,82.952-34.36A116.544,116.544,0,0,1,169.171,446.729Zm0-233.649a116.336,116.336,0,1,0,82.262,34.074A115.575,115.575,0,0,0,169.171,213.08Z" transform="translate(-24.887 -150.917)" fill="url(#linear-gradient-4)"/>
    <g id="矩形_3033" data-name="矩形 3033" transform="translate(35.266 87.067)" fill="#fff" stroke="var(--theme-color-1,#000)" stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <g id="矩形_3619" data-name="矩形 3619" transform="translate(346.717 87.067)" fill="#fff" stroke="var(--theme-color-2,#000)"  stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <g id="矩形_3616" data-name="矩形 3616" transform="translate(35.266 151.032)" fill="#fff" stroke="var(--theme-color-1,#000)" stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <g id="矩形_3621" data-name="矩形 3621" transform="translate(346.717 151.032)" fill="#fff" stroke="var(--theme-color-2,#000)"  stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <g id="矩形_3618" data-name="矩形 3618" transform="translate(35.266 214.997)" fill="#fff" stroke="var(--theme-color-1,#000)" stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <g id="矩形_3623" data-name="矩形 3623" transform="translate(346.717 214.997)" fill="#fff" stroke="var(--theme-color-2,#000)"  stroke-width="1">
      <rect width="141.506" height="41.445" rx="6" stroke="none"/>
      <rect x="0.5" y="0.5" width="140.506" height="40.445" rx="5.5" fill="none"/>
    </g>
    <text id="_41岁以上_3人" data-name="41岁以上，3人" transform="translate(62 112.067)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">41岁以上，3人</tspan></text>
    <text id="_41岁以上_3人-2" data-name="41岁以上，3人" transform="translate(362 112.067)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">41岁以上，3人</tspan></text>
    <text id="_31-40岁_4人" data-name="31-40岁，4人" transform="translate(62 176.032)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">31-40岁，4人</tspan></text>
    <text id="_31-40岁_4人-2" data-name="31-40岁，4人" transform="translate(363 176.032)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">31-40岁，4人</tspan></text>
    <text id="_18-30岁_3人" data-name="18-30岁，3人" transform="translate(62 239.997)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">18-30岁，3人</tspan></text>
    <text id="_18-30岁_4人" data-name="18-30岁，4人" transform="translate(363 239.997)" fill="#333" font-size="14" font-weight="500" letter-spacing="0.09em"><tspan x="0" y="0">18-30岁，4人</tspan></text>
    <rect id="矩形_3045" data-name="矩形 3045" width="6.077" height="41.445" transform="translate(35.266 87.067)" fill="var(--theme-color-1,#000)"/>
    <rect id="矩形_3620" data-name="矩形 3620" width="6.077" height="41.445" transform="translate(482.146 87.067)" fill="var(--theme-color-2,#000)"/>
    <rect id="矩形_3615" data-name="矩形 3615" width="6.077" height="41.445" transform="translate(35.266 151.032)" fill="var(--theme-color-1,#000)"/>
    <rect id="矩形_3622" data-name="矩形 3622" width="6.077" height="41.445" transform="translate(482.145 151.032)" fill="var(--theme-color-2,#000)"/>
    <rect id="矩形_3617" data-name="矩形 3617" width="6.077" height="41.445" transform="translate(35.266 214.997)" fill="var(--theme-color-1,#000)"/>
    <rect id="矩形_3624" data-name="矩形 3624" width="6.077" height="41.445" transform="translate(482.146 214.997)" fill="var(--theme-color-2,#000)"/>
  </g>

</svg>
`;
</script>
<style lang="scss" scoped>
.svg-block {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
